import { defineStore, storeToRefs } from 'pinia'
import { IVoucherList, ILockVoucherList, IVipLevel } from "@/@types/types";
import { apiFlushConfirm, apiGetLockVoucherList, apiGetUseVoucherList } from '@/api/voucher'
import { createUuid } from '@/utils/createUuid'
import { IFlushConfirm, IFlushConfirmRed, IFlushData } from "@/api/types/voucherTypes";
import { useLanguageStore } from '@/store/modules/language'
import { useCommonStatus } from '@/store/modules/commonStaus'
import eventBus, { COMMON_EVENT_NAME } from '@/utils/eventBus'
import { useAuthStore } from '@/store/modules/auth'

export const useVoucherStore = defineStore('voucher', {
  state: () => ({
    voucherCenterVisible: false as boolean,
    voucherUseVisible: false as boolean,
    useVoucherVisible: false as boolean,
    useVoucherList: [] as IVoucherList[],
    lockVoucherList: [] as ILockVoucherList[],
    disabledVoucherList: [] as IVoucherList[], // 当前不可用字段
    myVoucherList: [] as IVoucherList[],

    currentNid: -1 as number,
    currentVoucher: null as IVoucherList | null,
    currentVoucherPrice: 0 as number,
    currentPayTypeId: 0 as number,
    isShowVoucherDrawer: false as boolean,
    tempUUid: '' as string,
    isLoadingVoucher: false as boolean,

    nextAmount: 0 as number,
    vipName: '' as IVipLevel,
    vipCurrency: '' as string,

    firstChargeData: {
      sdkPayDiscount: 0,
      limitSku: '',
      currency: '',
      sdkPayAmount: 0,
      popSkuPriceReal: 0,
      popSkuPrice: 0,
      skuIcon: ''
    },

    flushData: {} as IFlushData,

    firstVoucher:  null as IVoucherList | null,
  }),
  actions: {
    setVoucherCenterVisible(voucherCenterVisible: boolean) {
      this.voucherCenterVisible = voucherCenterVisible
    },
    setUseVoucherVisible(useVoucherVisible: boolean) {
      this.useVoucherVisible = useVoucherVisible
    },
    setUseVoucherList(useVoucherList: IVoucherList[]) {
      console.log('useVoucherList', useVoucherList)
      this.useVoucherList = useVoucherList
    },
    setCurrentNid(currentNid: number) {
      console.log('setCurrentNid', currentNid)
      this.currentNid = currentNid
    },
    setCurrentVoucher(currentVoucher: IVoucherList | null) {
      this.currentVoucher = currentVoucher
    },
    // 计算最大代金券
    maxPrice(data: IVoucherList[]) {
      if (this.currentPayTypeId === -101) {
        return
      }

      let max = 100000000000000000
      let id: number = 0
      let currentVoucher: IVoucherList = {} as IVoucherList
      const temp: IVoucherList[] = []
      data.forEach((item: IVoucherList) => {
        if (item.finalAmount && Number(item.finalAmount) < max) {
          this.currentVoucherPrice = item.finalAmount || 0
          temp.push(item)
          id = item.id
          currentVoucher = item
          max = item.finalAmount
        }
      })
      this.currentNid = id
      this.currentVoucher = currentVoucher
      if (!id) {
        this.currentVoucherPrice = 0
      }
      console.log('currentVoucher11111', currentVoucher)
    },
    initVoucherData() {
      this.myVoucherList = []
      this.lockVoucherList = []
      this.disabledVoucherList = []
      this.currentVoucherPrice = 0
    },
    // 获取可使用的代金券列表
    async getUseVoucherList(
      payRegion: string,
      gameId: number | string,
      cpUid: string,
      serverId: string,
      amount: string | number,
      isUpdateGoods: boolean = true
    ) {
      this.initVoucherData()
      this.isLoadingVoucher = true
      const res: any = await apiGetUseVoucherList({
        mall_game_id: gameId,
        cpUid,
        server_id: serverId,
        amount,
        payRegion
      }).finally(() => {
        this.isLoadingVoucher = false
      })

      if (res.code === 0) {
        if (res.data.length > 0) {
          const result = res.data
          // const voucherTemp: IVoucherList[] = []
          // const disableVoucher: IVoucherList[] = []
          const myVoucherList: IVoucherList[] = []
          result.forEach((p: IVoucherList) => {
            if (p.status === 2) {
              myVoucherList.push(p)
            }
            // 有代金券结算金额，状态是可用的，过期时间大于当前时间，才可用
            // if (p.finalAmount && p.status === 2 && p.actExpiredAt > new Date().getTime()) {
            //   voucherTemp.push(p)
            // } else {
            //   disableVoucher.push(p)
            // }
            // return true
          })
          this.myVoucherList = myVoucherList
          // this.maxPrice(voucherTemp)
        } else {
          this.initVoucherData()
        }
      } else {
        this.initVoucherData()
      }
      if (isUpdateGoods) {
        eventBus.emit(COMMON_EVENT_NAME.REFRESH_GOODS_LIST)
      }
    },
    // 获取冻结的代金券
    async getLockVoucherList(params: IFlushConfirmRed) {
      this.lockVoucherList = []
      const res = await apiGetLockVoucherList({
        mall_game_id: params.mall_game_id,
        cpUid: params.cpUid,
        server_id: params.server_id,
        payRegion: params.payRegion
      })
      if (res.code === 0) {
        this.lockVoucherList = res.data as ILockVoucherList[]
      }
    },
    // 刷新是否可领取代金券代金券
    async freshVoucher(params: IFlushConfirm, isOpenVoucher: boolean = true) {

      // const route = useRoute()
      const { setVerifyRole } = useAuthStore()
      const { setFirstChargeVisible } = useCommonStatus()
      const { payLoadingVisible, firstChargeVisible } = storeToRefs(useCommonStatus())
      console.log('firstChargeVisible', firstChargeVisible.value)
      if(firstChargeVisible.value) {
        setFirstChargeVisible(false)
      }

      const { currentCountry } = storeToRefs(useLanguageStore())
      const res = await apiFlushConfirm({
        mall_game_id: params.mall_game_id,
        cpUid: params.cpUid,
        server_id: params.server_id,
        payRegion: currentCountry.value.key
      })
      if (res.code === 0) {
        this.flushData = res.data
        this.nextAmount = res.data.nextAmount
        this.vipName = res.data.vipName as IVipLevel
        this.vipCurrency = res.data.currency

        // 用于更新role_id
        if (res.data.currentRole) {
          setVerifyRole(res.data.currentRole)
          const localRoleInfo = JSON.parse(localStorage.getItem('gameRoleInfo') || '{}')
          localRoleInfo[window.globalRoute.path] = res.data.currentRole
          localStorage.setItem('gameRoleInfo', JSON.stringify(localRoleInfo))
        }

        // && res.data.discountRate !== '100'
        if(isOpenVoucher && res.data.popBenefit && !payLoadingVisible.value) {
          setFirstChargeVisible(true)
          this.firstChargeData.sdkPayDiscount = res.data.sdkPayDiscount
          this.firstChargeData.currency = res.data.currency
          this.firstChargeData.sdkPayAmount = res.data.sdkPayAmount
          this.firstChargeData.popSkuPriceReal = res.data.popSkuPriceReal
          this.firstChargeData.popSkuPrice = res.data.popSkuPrice
          this.firstChargeData.skuIcon = res.data.skuIcon
          this.firstVoucher = res.data.popBenefit as IVoucherList
          eventBus.emit(COMMON_EVENT_NAME.REFRESH_GOODS_LIST)
          return
        }
        this.firstChargeData = {
          sdkPayDiscount: 0,
          limitSku: '',
          currency: '',
          sdkPayAmount: 0,
          popSkuPriceReal: 0,
          popSkuPrice: 0,
          skuIcon: ''
        }
        this.firstVoucher = null

        if (res.data.flushBenefit && !payLoadingVisible.value && isOpenVoucher && res.data.payAmount) {
          this.voucherCenterVisible = true
        }
      }
    },
    // 生成临时uuid
    setTempUUid(path: string) {
      const data = localStorage.getItem('temp_uuid_new')
      const uuid = createUuid()
      if (!data) {
        const TEMP_UUID_GAMES = {
          [path]: uuid
        }
        this.tempUUid = uuid
        localStorage.setItem('temp_uuid_new', JSON.stringify(TEMP_UUID_GAMES))
      } else {
        try {
          const TEMP_UUID_GAMES = JSON.parse(data)
          if (!TEMP_UUID_GAMES[path]) {
            TEMP_UUID_GAMES[path] = uuid
            localStorage.setItem('temp_uuid_new', JSON.stringify(TEMP_UUID_GAMES))
            this.tempUUid = uuid
          } else {
            this.tempUUid = TEMP_UUID_GAMES[path]
          }
        } catch (error) {
          console.log(error)
        }
      }
    }
  },
  persist: {
    key: '__mall_voucher_store__',
    storage: localStorage,
    paths: ['formData', 'verifyRole']
  }
})
